import { useEffect, useState, useRef } from "react";
import { generateFileUrl, userRequest } from "../../requestMethods";
import "../../global.css";
import "./highlights.css";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { formatPricing } from "../../util/helper";
import { getProducts } from "../../redux/apiCalls";
import { useCompany } from "../../components/context/CompanyContext";
import { returnFormData, returnValidaVideo } from "../../util/helper";
import VideoImg from "../../components/VideoImg";
import Button from "@mui/material/Button";
import SaveIcon from "@mui/icons-material/Save";
import Avatar from "@mui/material/Avatar";
import CustomGrid from "../../components/grid/CustomGrid";
import { arrayMoveImmutable } from "array-move";
import SortableList, { SortableItem } from "react-easy-sort";
import { ContainerFile } from "../product/components/ContainerFile";
import { TrashButton } from "../product/components/TrashButton";
import {
  toBannerName,
  normalizeBanners,
  resolveBannerNames,
} from "../../util/banners";

const HOME_LAYOUTS = [
  { value: "default",           label: "Padrão" },
  { value: "category",          label: "Categoria" },
  { value: "highligh_category", label: "Categoria em Destaque" },
  { value: "multi_category",    label: "Multi Categoria" },
];

export default function Highlights() {
  const location = useLocation();
  const [home, setHome] = useState({});
  const [files, setFiles] = useState([]);
  const [videos, setVideos] = useState({});
  const [videoIni, setVideoIni] = useState();
  const [inputs, setInputs] = useState({});
  const [prdsTitle1, setprdsTitle1] = useState([{}]);
  const [prdsTitle2, setprdsTitle2] = useState([{}]);
  const [prdsTitle3, setprdsTitle3] = useState([{}]);
  const [youtubeLink, setYoutubeLink] = useState();
  const [tipoHi1, setTipoHi1] = useState("carrossel");
  const [tipoHi2, setTipoHi2] = useState("carrossel");
  const [homeLayout, setHomeLayout] = useState("default");
  const [companyConfigUI, setCompanyConfigUI] = useState({});
  const currentUser = useSelector((state) => state.user.currentUser);
  const [checked, setChecked] = useState(true);
  const inputTitle1 = useRef("");
  const inputSubtitle1 = useRef("");
  const inputTitle2 = useRef("");
  const inputSubtitle2 = useRef("");
  const inputYoutube = useRef("");
  const inputRef = useRef();
  const inputRefVideo = useRef();
  const nav = useNavigate();
  const { companyId, slug } = useCompany();
  const dispatch = useDispatch();
  const products = useSelector((state) => state.product.products);

  useEffect(() => {
    getHome();
    getCompanyConfig();
    getProducts(dispatch, false, companyId);
  }, [dispatch, companyId]);

  useEffect(() => {
    if (home && Object.keys(home).length > 0) {
      setChecked(home.allproducts);
      setFiles(normalizeBanners(home.banners));
      setVideos(home.videos);
      setYoutubeLink(home.youtubeLink);

      if (home.videos && home.videos.length > 0) {
        setVideoIni(true);
      } else {
        setVideoIni(false);
      }
      selectGrid1();
      selectGrid2();
      selectGrid3();
    }
  }, [home]);

  const [selectionModel1, setSelectionModel1] = useState();
  const [selectionModel2, setSelectionModel2] = useState();
  const [selectionModel3, setSelectionModel3] = useState();

  const selectGrid1 = () => {
    if (home.hightlights) {
      setprdsTitle1(home.hightlights[0].products);
      if (
        home.hightlights[0].products &&
        home.hightlights[0].products !== undefined
      )
        setSelectionModel1(home.hightlights[0].products);
      if (home.hightlights[0].tipoHi) {
        setTipoHi1(home.hightlights[0].tipoHi);
      }
    }
  };
  const selectGrid2 = () => {
    if (home.hightlights) {
      if (home.hightlights.length > 1) {
        setprdsTitle2(home.hightlights[1].products);
        setSelectionModel2(home.hightlights[1].products);
        if (home.hightlights[1].tipoHi) {
          setTipoHi2(home.hightlights[1].tipoHi);
        }
      }
    }
  };
  const selectGrid3 = () => {
    if (home.productsVideos) {
      if (home.productsVideos.length > 1) {
        setSelectionModel3(home.productsVideos);
      }
    }
  };
  const getHome = async () => {
    try {
      const res = await userRequest.get(`${companyId}/home/admin`);

      if (Object.keys(res.data).length > 0) {
        setHome(res.data);
      }
    } catch {
      console.log();
    }
  };

  const getCompanyConfig = async () => {
    try {
      const res = await userRequest.get(`${companyId}/company`);
      if (res.data && res.data.configUI) {
        setCompanyConfigUI(res.data.configUI);
        setHomeLayout(res.data.configUI.layout || "default");
      }
    } catch {}
  };

  const updateLayout = async () => {
    await userRequest.put(`${companyId}/company/`, {
      configUI: { ...companyConfigUI, layout: homeLayout },
    });
  };
  const validadeListProduct = () => {
    if (prdsTitle1.length < 3 || prdsTitle1.length > 20) {
      Swal.fire(
        "Atenção!",
        "A lista de produtos 1 deve ter no mínimo 3 e máximo 20 produtos.",
        "warning",
      );

      return false;
    }
    return true;
  };
  const validadeListProduct2 = () => {
    if (!validateTitle2()) {
      if (prdsTitle2.length < 3 || prdsTitle2.length > 20) {
        Swal.fire(
          "Atenção!",
          "A lista de produtos 2 deve ter no mínimo 3 e máximo 20 produtos.",
          "warning",
        );
        return false;
      }
    }
    return true;
  };
  const validate = () => {
    if (
      inputTitle1.current.value === "" ||
      inputTitle1.current.value === undefined
    ) {
      return false;
    }
    if (
      inputSubtitle1.current.value === "" ||
      inputSubtitle1.current.value === undefined
    ) {
      return false;
    }
    if (!validateTitle2()) {
      return false;
    }
    return true;
  };
  const validateTitle2 = () => {
    if (
      inputSubtitle2.current.value !== "" &&
      (inputTitle2.current.value === "" ||
        inputTitle2.current.value === undefined)
    ) {
      return false;
    }
    return true;
  };

  const cadastrarClick = async (event) => {
    let upload = true;
    if (!videoIni) {
      upload = await handleUploadVideo();
    }
    if (!upload) {
      return;
    }

    const isUpdate = Object.keys(home).length > 0;

    // Valida ANTES de subir os banners novos, evitando uploads órfãos no S3
    // quando o formulário está incompleto.
    if (isUpdate) {
      if (!validadeListProduct() || !validadeListProduct2()) {
        return;
      }
    } else if (!(validate() && validadeListProduct() && validadeListProduct2())) {
      Swal.fire(
        "Atenção!",
        "Os campos Título, Subtítulo e a lista produtos devem ser preenchidos",
        "warning",
      );
      return;
    }

    let banners;
    try {
      banners = await buildBanners();
    } catch (error) {
      console.error(error);
      Swal.fire("Atenção!", "Erro ao enviar os banners!", "error");
      return;
    }

    // Sincroniza o estado com a lista resolvida (strings) para que um novo
    // "Salvar" não tente reenviar os mesmos arquivos.
    setFiles(banners);

    if (isUpdate) {
      Update(banners);
    } else {
      Inserir(banners);
    }
    updateLayout().catch(() => {});
  };
  const Update = async (banners) => {
    try {
      const res = await userRequest.put(`${companyId}/home/`, {
        allproducts: checked,
        banners: banners,
        hightlights: objHilights(),
        lastUserUpdate: currentUser.userId,
        productsVideos: prdsTitle3,
        youtubeLink: inputYoutube.current.value,
      });
      if (Object.keys(res.data).length > 0) {
        Swal.fire("Parabéns!", "Home do app alterado com sucesso!", "success");
      } else {
        Swal.fire("Atenção!", "Erro ao alterar a home!", "error");
      }
    } catch (error) {
      console.log("Update", error);
    }
  };

  const objHilights = () => {
    let arrayHighlights = [];
    arrayHighlights.push({
      title: inputTitle1.current.value,
      subTitle: inputSubtitle1.current.value,
      products: prdsTitle1,
      tipoHi: tipoHi1,
      sort: 0,
    });

    if (inputTitle2.current.value !== "") {
      arrayHighlights.push({
        title: inputTitle2.current.value,
        subTitle: inputSubtitle2.current.value,
        products: prdsTitle2,
        tipoHi: tipoHi2,
        sort: 1,
      });
    }

    return arrayHighlights;
  };
  const Inserir = async (banners) => {
    try {
      const res = await userRequest.post(`${companyId}/home/`, {
        allproducts: checked,
        banners: banners,
        hightlights: objHilights(),
        lastUserUpdate: currentUser.userId,
        productsVideos: prdsTitle3,
        youtubeLink: inputYoutube.current.value,
      });
      if (Object.keys(res.data).length > 0) {
        Swal.fire("Parabéns!", "Home do app inserida com sucesso!", "success");
      } else {
        Swal.fire("Atenção!", "Erro ao inserir a home do app!", "error");
      }
    } catch (error) {
      console.log(error);
    }
  };
  // Banner novo é sempre um File (acabou de ser selecionado). Banners salvos
  // são strings/objetos. Esse teste evita tratar objeto legado como File
  // (o que quebraria URL.createObjectURL).
  const isNewBanner = (item) => item instanceof File;

  const onSortEnd = (oldIndex, newIndex) => {
    setFiles((array) => arrayMoveImmutable(array, oldIndex, newIndex));
  };

  // Faz upload apenas dos banners novos (File) e devolve a lista final ordenada
  // (strings), pronta para persistir junto da home — espelha o fluxo de fotos
  // do produto. O casamento arquivo→nome é por POSIÇÃO (ver resolveBannerNames).
  const buildBanners = async () => {
    const newFiles = files.filter(isNewBanner);

    if (!newFiles.length) {
      return normalizeBanners(files);
    }

    const formData = await returnFormData(newFiles, "banner");
    const res = await userRequest.post(
      `${companyId}/products/images/banners`,
      formData,
    );
    const uploaded = res.data.imageUrls || [];

    return resolveBannerNames(files, uploaded, isNewBanner);
  };
  const handleUploadVideo = async (event) => {
    if (videos) {
      if (videos.length > 0) {
        const formData = await returnFormData(videos, "video");

        const res = await userRequest.post(
          `${companyId}/products/images/videos`,
          formData,
        );

        if (res.status !== 200) {
          return false;
        }
      }
    }
    return true;
  };
  const handleChange = (e) => {
    setInputs((prev) => {
      return { ...prev, [e.target.name]: e.target.value };
    });
  };
  // Remove um banner ainda não salvo (File) apenas do estado local.
  const removeNewBanner = (file) => {
    setFiles((prev) => prev.filter((f) => f !== file));
  };

  // Remove um banner já salvo (string): apaga no backend (S3 + home) e
  // atualiza a lista local.
  const handleDeleteOneBanner = async (banner) => {
    try {
      await userRequest.put(`${companyId}/products/images/banner`, {
        image: banner,
      });
      setFiles((prev) => prev.filter((f) => f !== banner));
    } catch (error) {
      console.error(error);
      Swal.fire("Atenção!", "Erro ao excluir o banner!", "error");
    }
  };
  const handleOnDeleteVideo = (event) => {
    setVideoIni(false);
    setVideos({});

    const res = userRequest.delete(`${companyId}/products/images/deletevideos`);

    if (res.status === 200) {
      return true;
    } else {
      return false;
    }
  };
  const handleOnChange = (event) => {
    if (returnValidaVideo(event.target.files, false)) {
      const eventFiles = Object.keys(event.target.files).map(
        (key) => event.target.files[key],
      );
      setFiles((prev) => [...prev, ...eventFiles]);
    }
    // permite reselecionar o mesmo arquivo em sequência
    event.target.value = "";
  };
  const handleOnChangeVideo = (event) => {
    // caramella é isenta do limite de tamanho do Vídeo Provador
    if (returnValidaVideo(event.target.files, true, slug)) {
      setVideos(event.target.files);
    }
  };
  const handleOnclick = (event) => {
    event.preventDefault();
    inputRef.current.click();
  };
  const handleOnclickVideo = (event) => {
    event.preventDefault();
    inputRefVideo.current.click();
  };

  const columns = [
    {
      field: "avatar",
      headerName: "Foto",
      headerClassName: "dataGridMuiHeader",
      align: "center",
      headerAlign: "center",
      width: 50,
      display: "flex",
      renderCell: (params) => {
        return (
          <>
            <Avatar
              sx={{ width: "30px", height: "30px" }}
              src={generateFileUrl(params.value)}
            />
          </>
        );
      },
    },
    {
      field: "title",
      type: "text",
      align: "left",
      headerName: "Produto",
      headerClassName: "dataGridMuiHeader",
      width: 250,
      display: "flex",
      renderCell: (params) => {
        return (
          <div className="productListItem">
            <img className="productListImg" src={params.row.img} alt="" />
            {params.row.title}
          </div>
        );
      },
    },
    {
      field: "ref",
      type: "text",
      headerName: "Referência",
      width: 80,
      headerClassName: "dataGridMuiHeader",
      align: "center",
    },
    // {
    //   field: "category",
    //   headerName: "Categoria",
    //   headerClassName: "dataGridMuiHeader",
    //   width: 200,
    //   align: "left",
    // },
    {
      field: "discount",
      headerName: "Preço",
      width: 100,
      align: "center",
      headerAlign: "center",
      type: "number",
      format: "BRL",
      headerClassName: "dataGridMuiHeader",
      valueFormatter: (value) => {
        if (value === null) {
          return "";
        }
        return `${formatPricing(value)}`;
      },
    },
    {
      field: "price",
      headerName: "Preço com Desconto",
      width: 160,
      align: "center",
      headerAlign: "center",
      format: "BRL",
      type: "number",
      headerClassName: "dataGridMuiHeader",
      valueFormatter: (value) => {
        if (value === null) {
          return "";
        }
        return `${formatPricing(value)}`;
      },
    },
    // {
    //   field: "discount",
    //   headerName: "Desconto",
    //   width: 200,
    //   headerClassName: "dataGridMuiHeader",
    //   align: "left",
    //   valueFormatter: (params) => formatPricing(params?.value),
    // },
  ];

  return (
    <div className="cust-page">
      <div className="cust-title">Home App</div>

      {/* Layout da Home */}
      <div className="cust-card">
        <div className="cust-section-header">Layout da Home</div>
        <div className="cust-fields">
          <div className="cust-field">
            <label className="cust-label">Tipo de layout</label>
            <select
              className="cust-select"
              value={homeLayout}
              onChange={(e) => setHomeLayout(e.target.value)}
            >
              {HOME_LAYOUTS.map((opt) => (
                <option key={opt.value} value={opt.value}>{opt.label}</option>
              ))}
            </select>
          </div>
        </div>
      </div>

      {/* Banners */}
      <div className="cust-card">
        <div className="cust-section-header">Banners</div>
        <div style={{ padding: "16px" }}>
          {files && files.length > 0 && (
            <SortableList
              onSortEnd={onSortEnd}
              className="sortable-container"
              draggedItemClassName="banner-dragged"
            >
              {files.map((item) => {
                const isNewFile = isNewBanner(item);
                const name = isNewFile ? item : toBannerName(item);
                const key = isNewFile ? item.name + item.lastModified : name;
                return (
                  <SortableItem key={key}>
                    <div>
                      <ContainerFile>
                        <TrashButton
                          handleClick={
                            isNewFile ? removeNewBanner : handleDeleteOneBanner
                          }
                          itemToDelete={item}
                        />
                        <VideoImg
                          filesIni={!isNewFile}
                          item={name}
                          classImg="bannerUpload"
                          classVideo="bannerUpload"
                        />
                      </ContainerFile>
                    </div>
                  </SortableItem>
                );
              })}
            </SortableList>
          )}
          <div style={{ marginTop: "12px" }}>
            <input
              type="file"
              multiple
              onChange={handleOnChange}
              hidden
              accept="image/png, image/jpeg, video/mp4"
              ref={inputRef}
            />
            {currentUser.isAdmin && (
              <Button
                variant="outlined"
                className="custom_mui_action"
                onClick={handleOnclick}
              >
                Selecione os banners
              </Button>
            )}
          </div>
        </div>
      </div>

      {/* Highlights 1 */}
      <div className="cust-card">
        <div className="cust-section-header">Highlights 1</div>
        <div className="cust-fields">
          <div className="cust-field">
            <label className="cust-label">Título</label>
            <textarea
              rows="3"
              type="text"
              className="cust-textarea"
              name="title1"
              defaultValue={
                home && home.hightlights ? home.hightlights[0].title : ""
              }
              onChange={handleChange}
              maxLength="310"
              ref={inputTitle1}
            />
          </div>
          <div className="cust-field">
            <label className="cust-label">Subtítulo</label>
            <textarea
              rows="3"
              type="text"
              name="substitle1"
              defaultValue={
                home && home.hightlights ? home.hightlights[0].subTitle : ""
              }
              className="cust-textarea"
              onChange={handleChange}
              ref={inputSubtitle1}
              maxLength="200"
            />
          </div>
          <div className="cust-field">
            <label className="cust-label">Tipo highlights</label>
            <select
              className="cust-select"
              name="tipohighlights"
              value={tipoHi1}
              onChange={(e) => setTipoHi1(e.target.value)}
            >
              <option value="semhi">Sem Highlights</option>
              <option value="carrossel">Carrossel</option>
              <option value="grid">Grid</option>
            </select>
          </div>
        </div>
        <div style={{ padding: "16px" }}>
          <CustomGrid
            gridId="hi1List"
            rows={products.products}
            columns={columns}
            pageSize={10}
            checkboxSelection={true}
            selectionField="productId"
            selectionModel={selectionModel1}
            onSelectionChange={(selected, changed) => {
              setSelectionModel1(selected);
              setprdsTitle1(selected);
            }}
          />
        </div>
      </div>

      {/* Highlights 2 */}
      <div className="cust-card">
        <div className="cust-section-header">Highlights 2</div>
        <div className="cust-fields">
          <div className="cust-field">
            <label className="cust-label">Título 2</label>
            <input
              type="text"
              className="cust-input"
              name="title2"
              defaultValue={
                home && home.hightlights && home.hightlights.length > 1
                  ? home.hightlights[1].title
                  : ""
              }
              onChange={handleChange}
              ref={inputTitle2}
              maxLength="100"
            />
          </div>
          <div className="cust-field">
            <label className="cust-label">Subtítulo 2</label>
            <input
              type="text"
              name="substitle2"
              defaultValue={
                home && home.hightlights && home.hightlights.length > 1
                  ? home.hightlights[1].subTitle
                  : ""
              }
              className="cust-input"
              onChange={handleChange}
              ref={inputSubtitle2}
              maxLength="200"
            />
          </div>
          <div className="cust-field">
            <label className="cust-label">Tipo highlights</label>
            <select
              className="cust-select"
              name="tipohighlights"
              value={tipoHi2}
              onChange={(e) => setTipoHi2(e.target.value)}
            >
              <option value="semhi">Sem Highlights</option>
              <option value="carrossel">Carrossel</option>
              <option value="grid">Grid</option>
            </select>
          </div>
        </div>
        <div style={{ padding: "16px" }}>
          <CustomGrid
            gridId="hi2List"
            rows={products.products}
            columns={columns}
            pageSize={10}
            checkboxSelection={true}
            selectionField="productId"
            selectionModel={selectionModel2}
            onSelectionChange={(selected, changed) => {
              setSelectionModel2(selected);
              setprdsTitle2(selected);
            }}
          />
        </div>
      </div>

      {/* Vídeo Provador */}
      <div className="cust-card">
        <div className="cust-section-header">Vídeo Provador</div>
        <div style={{ padding: "16px" }}>
          {videos && videos.length > 0 ? (
            <div className="uploads">
              {Array.from(videos).map((item, index) => (
                <VideoImg
                  key={index}
                  filesIni={videoIni}
                  item={item.newName ? item.newName : item}
                  classImg="bannerUpload"
                  classVideo="bannerUpload"
                />
              ))}
              <div>
                <Button
                  variant="outlined"
                  className="custom_mui_action"
                  onClick={handleOnDeleteVideo}
                >
                  Excluir Vídeo
                </Button>
              </div>
            </div>
          ) : (
            <div>
              <input
                type="file"
                multiple
                onChange={handleOnChangeVideo}
                hidden
                accept="video/mp4"
                ref={inputRefVideo}
              />
              {currentUser.isAdmin && (
                <Button
                  variant="outlined"
                  className="custom_mui_action"
                  onClick={handleOnclickVideo}
                >
                  Selecione o vídeo
                </Button>
              )}
            </div>
          )}
        </div>
        {((home.videos && home.videos.length > 0) ||
          (videos && videos.length > 0)) && (
          <div style={{ padding: "16px" }}>
            <label className="cust-label">Produtos relacionados ao vídeo</label>
            <CustomGrid
              gridId="hi3List"
              rows={products.products}
              columns={columns}
              pageSize={10}
              checkboxSelection={true}
              selectionField="productId"
              selectionModel={selectionModel3}
              onSelectionChange={(selected, changed) => {
                setSelectionModel3(selected);
                setprdsTitle3(selected);
              }}
            />
          </div>
        )}
      </div>

      {/* YouTube */}
      <div className="cust-card">
        <div className="cust-section-header">Vídeo YouTube</div>
        <div className="cust-fields">
          <div className="cust-field">
            <label className="cust-label">Link YouTube</label>
            <input
              type="text"
              name="youtube"
              defaultValue={home && home.youtubeLink ? youtubeLink : ""}
              className="cust-input"
              onChange={handleChange}
              ref={inputYoutube}
              maxLength="60"
            />
          </div>
        </div>
      </div>

      <div className="cust-footer">
        {currentUser.isAdmin && (
          <Button
            variant="contained"
            color="secondary"
            startIcon={<SaveIcon />}
            onClick={cadastrarClick}
            size="small"
          >
            Salvar
          </Button>
        )}
      </div>
    </div>
  );
}
